import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as fromActions from '../actions/settings.actions';
import { AumicoSettingsService } from '../services/aumico-settings.service';
import { getDebug, getTag } from '../utils/debugUtil';

const filename = './src/lib/effects/financial-line-item.effects.ts';
const debug = getDebug(filename);
const TAG = getTag(filename);

@Injectable()
export class FinancialLineItemEffects {
    constructor(private actions$: Actions, private service: AumicoSettingsService) {}

    getAllFinancialLineItem$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.financialLineItemActions.getAllFinancialLineItem),
            mergeMap((action) => {
                return this.service.getAllFinancialLineItem().pipe(
                    map((response) => {
                        return fromActions.financialLineItemActions.onGetAllFinancialLineItemSuccess({
                            payload: response,
                        });
                    }),
                    catchError((error) => {
                        return of(
                            fromActions.financialLineItemActions.onGetAllFinancialLineItemFailed({ payload: error }),
                        );
                    }),
                );
            }),
        ),
    );

    submitCreateFinancialLineItem$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.financialLineItemActions.submitCreateFinancialLineItem),
            mergeMap((action) => {
                const observable$ = this.service.createFinancialLineItem(action.payload);
                return observable$.pipe(
                    map(() => {
                        return fromActions.financialLineItemActions.onSubmitCreateFinancialLineItemSuccess();
                    }),
                    catchError((error) => {
                        return of(
                            fromActions.financialLineItemActions.onSubmitCreateFinancialLineItemFailed({
                                payload: error,
                            }),
                        );
                    }),
                );
            }),
        ),
    );

    submitEditFinancialLineItem$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.financialLineItemActions.submitEditFinancialLineItem),
            mergeMap((action) => {
                const observable$ = this.service.updateFinancialLineItem(action);
                return observable$.pipe(
                    map(() => {
                        return fromActions.financialLineItemActions.onSubmitEditFinancialLineItemSuccess();
                    }),
                    catchError((error) => {
                        return of(
                            fromActions.financialLineItemActions.onSubmitEditFinancialLineItemFailed({
                                payload: error,
                            }),
                        );
                    }),
                );
            }),
        ),
    );
}
